<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 二手车信息管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-table
                :data="listusedcar"
                border
                class="table"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="equipmentCode" label="设备编号"></el-table-column>
				<el-table-column prop="machineryBrand" label="机械品牌"></el-table-column>
				<el-table-column prop="machineryType" label="机械类型"></el-table-column>
				<el-table-column prop="productionCountry" label="生产国别"></el-table-column>
				<el-table-column prop="productionDateStr" label="出厂日期"></el-table-column>
				<el-table-column prop="createTimeStr" label="发布日期"></el-table-column>
				<el-table-column prop="personName" label="发布人"></el-table-column>
				<el-table-column prop="effectiveDay" label="有效时间(天)"></el-table-column>
				<el-table-column prop="isValidStr" label="状态" align="center">
					<template slot-scope="scope">
						 <span v-if="scope.row.isValid == 1">
							 有效
						 </span>
						 <span v-else style="color: red;">
							 已下架
						 </span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
				    <template slot-scope="scope">
						<el-button
						    type="text"
						    icon="el-icon-view"
						    @click="usercarsSee(scope.row)"
						>查看</el-button>
				      <!--  <el-button
				            type="text"
				            @click="usercarsDelete(scope.row)"
				        >下架</el-button> -->
				    </template>
				</el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
        <!-- 查看弹框 -->
        <el-dialog class="branch-dialog" title="查看二手车信息" :visible.sync="seeuserdcarVisible" width="600px">
        	<p class="branch-dialog-title">
        		二手车信息维护
        	</p>
        	<div class="livingsee">
				<p>设备编号: <span>{{seeusedcar.equipmentCode}}</span></p>
				<ul class="usercars-info">
					<li>排放登记: <span>{{seeusedcar.emissionRegistration}}</span></li>
					<li>生产国别: <span>{{seeusedcar.productionCountry}}</span></li>
					<li>发动机功率: <span>{{seeusedcar.enginePower}}</span></li>
					<li>燃油类型: <span>{{seeusedcar.fuelType}}</span></li>
					<li>机械品牌: <span>{{seeusedcar.machineryBrand}}</span></li>
					<li>整机质量: <span>{{seeusedcar.overallQuality}}</span></li>
					<li>机械颜色: <span>{{seeusedcar.machineryColor}}</span></li>
					<li>出厂日期: <span>{{seeusedcar.productionDateStr}}</span></li>
					<li>机械类型: <span>{{seeusedcar.machineryType}}</span></li>
					<li>核载质量: <span>{{seeusedcar.nuclearInformation}}</span></li>
				</ul>
        		
				<ul class="living-img">
					<li v-for="item in seeusedcar.mechanicalPictures">
						<img :src="'/api/static'+item" alt="">
					</li>
				</ul>
				<el-button v-if="seeusedcar.isValid == 1" type="primary"  @click="usercarsDelete(seeusedcar,2)">下架</el-button>
				<el-button v-else type="primary"  @click="usercarsDelete(seeusedcar,1)">上架</el-button>
				
        	</div>
        	
            
        </el-dialog>
    </div>
</template>




<script>
import { listUsedCars,deleteUsedCar} from '@/api/index';// 导入我们的api接口
export default {
    name: 'usedcars',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,
            listusedcar: [],  //列表数据
			seeusedcar:[],   //查看内容
			
			seeuserdcarVisible:false,
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistUsedCars();
    },
    methods: {
		// 列表数据
		getlistUsedCars(){
			listUsedCars({
				current: this.query.pageIndex,                    
				size: this.query.pageSize               
			}).then(res => {
				// 获取数据成功后的其他操作
				this.listusedcar = res.data.records;
				this.pageTotal = res.data.total;
			});
		},
		// 查看操作
		usercarsSee(row){
			  this.seeuserdcarVisible = true; 
			  this.seeusedcar = row;
			  if(typeof this.seeusedcar.mechanicalPictures=='string'){
				  this.seeusedcar.mechanicalPictures = this.seeusedcar.mechanicalPictures.split(',');
			  }
			  
		},
       
        // 删除操作
        usercarsDelete(row,type) {
			// if(row.isValid == 1){
				this.$confirm('确认继续操作吗？', '提示', {
					type: 'warning'
				}).then(() => {
					deleteUsedCar({
						usedCarId:row.usedCarId,
						type:type
					}).then(res => {
						this.query.pageIndex = 1;
						this.getlistUsedCars();
						this.seeuserdcarVisible = false; 
						if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
						}else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						}else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						}
						
					});
				}).catch(() => {});
			// }else{
			// 	this.$message({
			// 		message: '该信息已下架!',
			// 		type: 'warning'
			// 	});
			// }
			
			
           
        },
       
    
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistUsedCars();
        }
    }
};
</script>

<style scoped>
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.usercars-info{
	display: flex;
	display: -webkit-flex;
	flex-wrap: wrap;
	padding: 0;
	margin: 0;
	list-style: none;
}
.usercars-info li{
	width: 40%;
	height: 32px;
	line-height: 32px;
	letter-spacing: 1px;
	font-size: 16px;
}
.usercars-info li:nth-child(2n){
	margin-left: 4%;
}

.livingsee p{
	height: 32px;
	line-height: 32px;
	letter-spacing: 1px;
	font-size: 16px;
}
.livingsee .el-button{
	width: 100px;
	margin-top: 30px;
}
.living-img {
	display: flex;
	display: -webkit-flex;
	flex-wrap: wrap;
	padding: 0;
	margin: 0;
	list-style: none;
}
.living-img li{
	width:256px;
	height: 144px;
	margin-top: 20px;
}
.living-img li:nth-child(2n){
	margin-left: 10px;
}
.living-img li img{
	width: 100%;
	height: 100%;
}
</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	width: 100px;
}
.branch-dialog .el-form-item__content{
	margin-left: 100px;
}
/* .branch-area .el-form-item__content{
	margin-top: 30px;
} */
.branch-area{
	text-align: right;
}
.branch-area i{
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem {
	position: relative;
	margin-top: 10px;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.select-box .el-select {
	width: 100%;
}
</style>
